import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultConnections,
  defaultConstruction,
  defaultContactInfo,
  defaultCosts,
  defaultDescription,
  defaultGastronomyBasicInfo,
  defaultGastronomyOtherFacilities,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerGastronomyRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  costs: defaultCosts,
  basicInfo: defaultGastronomyBasicInfo,
  otherFacilities: defaultGastronomyOtherFacilities,
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  connections: defaultConnections,
}
